import React from 'react';
import DeviationDuperbrowseContext from '../../../../Duperbrowse/DeviationDuperbrowseContext';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import { MeasuredCookieType } from '../../../../Measured/redux/types';
import { MeasuredContainer, measuredDefaultSize } from '../../../../Measured';
import StandardThumb from '../../../../DeviationViews/Thumb/Standard';
import s from './DeviationMobileList.scss';
/** Sidebar block layout id 5 */
var DeviationMobileList = function (_a) {
    var _b;
    var block = _a.block, parentDeviation = _a.deviation;
    return (React.createElement(SidebarBlockWrapper, { deviation: parentDeviation, block: block },
        React.createElement("div", { className: s['root'] },
            React.createElement(DeviationDuperbrowseContext, { streamId: "sidebar-mobilelist-" + block.contentType, deviations: (_b = block.deviations) !== null && _b !== void 0 ? _b : [], parent: {
                    typeId: getDeviationResourceType(parentDeviation),
                    itemId: parentDeviation.deviationId,
                } },
                React.createElement(MeasuredContainer, { cookieType: MeasuredCookieType.DEVIATION_MOBILE_SIDEBAR, cookieDim: 'width', defaultSize: measuredDefaultSize, listenOnWindow: true, limitToParentWidth: true, measureWindow: true }, function (_a) {
                    var _b;
                    var container = _a.container;
                    return (_b = block.deviations) === null || _b === void 0 ? void 0 : _b.slice(0, 5).map(function (deviation) { return (React.createElement(StandardThumb, { key: deviation.deviationId, deviation: deviation, width: container
                            ? container.width
                            : measuredDefaultSize.mobile.width, height: 239, className: s['thumb'] })); });
                })))));
};
DeviationMobileList.displayName = 'DeviationMobileList';
export default DeviationMobileList;
//# sourceMappingURL=DeviationMobileList.js.map